define([
	"dojo/_base/declare",
	"csi/table/New",
	"./ContractualDocumentFormActionMixin",
	"csi/comm",
	"csi/resolver",
	"csi/xml"
], function(declare,New,ContractualDocumentFormActionMixin,comm,resolver,xml) {

	return declare([ New, ContractualDocumentFormActionMixin ], {
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set fixed field values based on context
			this.inherited(arguments);
			var sourceObject = this.m_formData.getSource().getParent();
			this._initSourceObjectFormFields(view, sourceObject);
		},

		toWriterFields: function(/*String*/urlNode, /*FormData?*/fd) {
			this._adjustSaveScript(urlNode, fd);
			this.inherited(arguments);
		}
	});
});
